// extracted by mini-css-extract-plugin
module.exports = {"buttonBlock":"style_buttonBlock__IkjOT"};